module.exports = __webpack_public_path__ + "static/media/Go Pang Na_Erfolgsstory.224e89e9.webp";